import React, { Component, ReactNode } from 'react';
import { ButtonProps } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';

class CustomAnimateButton extends Component<Props> {
  render() {
    const { customSize, customType, icon, text, className, loading, ...rest } = this.props;
    return (
      <button
        {...rest}
        disabled={loading || rest.disabled}
        className={`${getType(customType) + ' '} ${getSize(customSize) + ' '} ${className} animate-button shadow-md rounded min-w-32  w-32  flex justify-start items-center disabled:cursor-not-allowed`}
      >
        <div className={`${getSize(customSize)} + " " w-1/4`}>{loading ? <ProgressSpinner style={{ height: '100%', width: '100%' }} /> : icon}</div>
        <span className='px-3 w-full flex text-lg items-center justify-center'>{text}</span>
      </button>
    );
  }
}

function getType(customType: string = 'deploy') {
  switch (customType) {
    case 'deploy':
      return 'animate-button-deploy';
    case 'undeploy':
      return 'animate-button-undeploy';
    case 'save':
      return 'animate-button-save !text-black';
    case 'remove':
      return 'animate-button-undeploy';
    case 'redeploy':
      return 'animate-button-deploy';
    case 'logout':
      return 'animate-button-logout';
    case 'cancel':
      return 'animate-button-cancel !text-primary';
    case 'not-fraud':
      return 'animate-button-not-fraud';
    default:
      return 'animate-button-deploy';
  }
}

function getSize(customSize: string = 'md') {
  switch (customSize) {
    case 'sm':
      return 'h-[34px]';
    case 'md':
      return 'h-10';
    case 'lg':
      return 'h-12';
  }
}

interface Props extends ButtonProps {
  icon: ReactNode;
  text: string;
  customType?: string;
  customSize?: string;
}

export default CustomAnimateButton;
